export const BADGE_KEY_INVOICE = 'invoice';

export interface Invoice {
  id?: string;
  number: string;
  pdfExists: boolean;
  pdfDownloadApiUrl: string;
  createdAt?: string;
  gross?: number;
  reverseInvoice?: Invoice;
  isReverseInvoice?: boolean;
  isTaxCertificate?: boolean;
  dunning?: Invoice[];
  dunningLevel?: number;
  canceled?: boolean;
  downloadedByMember?: boolean;
}
